module.exports = __webpack_public_path__ + "static/media/gc-bus-stop.13dfe3b9.png";